const $ = require("jquery");

/*
 * GA4 события + Google Ads conversions. До согласия на cookies gtag() — заглушка (см. config.php).
 * request и form_submit отправляются из config.php по загрузке form_* / success_*.
 */
function conversion(label) {
	gtag('event', 'conversion', {
		'send_to': 'AW-11191154034/' + label,
		'value': 1.0,
		'currency': 'EUR'
	});
}

$(document).on('click', 'a[href^="tel:"]', function() {
	gtag('event', 'phone', {
		'send_to': 'G-1P28YPR7V7',
		'event_category': 'contact',
	});
	conversion('bbHCCJ37ppUdEPLqrdgp'); // phone
});

$(document).on('click', 'a[href^="mailto:"]', function() {
	gtag('event', 'email', {
		'send_to': 'G-1P28YPR7V7',
		'event_category': 'contact',
	});
	conversion('2mxbCOzzppUdEPLqrdgp'); // email
});
